import {Component, Input} from '@angular/core';
import {CompetitorLiveResults} from 'src/app/model/live-results';
import {Gender} from "@model";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-live-results-table-body',
  templateUrl: './live-results-table-body.component.html',
  styleUrls: ['./live-results-table-body.component.scss'],
  animations: [
    trigger('animate', [
      state('*', style({transform: 'scaleY(1)', opacity: 1})),

      transition('void => *', [
        style({transform: 'translateY(100%)', opacity: 0}),
        animate(500),
      ]),
    ]),
  ],
})
export class LiveResultsTableBodyComponent {
  @Input() competitorLiveResults: CompetitorLiveResults[] = [];
  @Input() leading: CompetitorLiveResults[] = [];
  @Input() filterGender: Gender | undefined;
}
